module.exports = __webpack_public_path__ + "static/img/mjfBanner.74652cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mjfBanner.png
// module id = z7vv
// module chunks = 2